import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function createDirectSnSale(payload) {
  const { data: raw } = await request.post(
    '/crm/sn-sales-warranties/direct-sale',
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}

export async function fetchSnSalesWarranty(mtrSnId) {
  const { data: raw } = await request.get(`/crm/sn-sales-warranties/${mtrSnId}`);
  return parseVer4DetailResponse(raw);
}

export async function patchSnSalesWarranty(mtrSnId, payload) {
  const { data: raw } = await request.patch(
    `/crm/sn-sales-warranties/${mtrSnId}`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
